/* eslint-disable camelcase */
import { fetchData, postData } from 'modules/Axios';
import { showToast } from 'modules/Notifications';

import { parseFilters, parseAudienceSize } from '../../../../../components/ThoughtSpot/utils/parseThoughtSpotSearch';

export const defaultState = {
  brandHome: null,
  brandHomeLoading: false,
  searchData: null,
  searchFilters: [],
  searchAudienceSize: null,
  segments: [],
  totalSegments: 0,
  segmentDetails: null,
  lastCreatedAudience: null,
};

export const SET_EXPLORER_BRAND_HOME = 'SET_EXPLORER_BRAND_HOME';
export const setExplorerBrandHome = (brandHome) => ({
  type: SET_EXPLORER_BRAND_HOME,
  payload: brandHome,
});

export const SET_EXPLORER_BRAND_HOME_LOADING = 'SET_EXPLORER_BRAND_HOME_LOADING';
export const setExplorerBrandHomeLoading = () => ({
  type: SET_EXPLORER_BRAND_HOME_LOADING,
});

export const RESET_EXPLORER_BRAND_HOME = 'RESET_EXPLORER_BRAND_HOME';
export const resetExplorerBrandHome = () => ({
  type: RESET_EXPLORER_BRAND_HOME,
});

export const fetchExplorerBrandHome = (brandId) => {
  return async (dispatch, getState) => {
    const { brandHomeLoading } = getState().explorer;
    if (!brandHomeLoading) {
      dispatch(setExplorerBrandHomeLoading());
      try {
        const brandHome = await dispatch(
          fetchData(`/brands/${brandId}/integrations/thoughtspot/dashboards/homepage?fetch_objects=false`)
        );
        return dispatch(
          setExplorerBrandHome({
            brandId,
            id: brandHome?.metadata_id,
            name: brandHome?.metadata_name,
            path: `pinboard/${brandHome.metadata_id}`,
          })
        );
      } catch (e) {
        // Homepage not being set will return 404, but that's not an error case
        if (e?.message !== 'Request failed with status code 404') {
          console.error('API call to fetch Explorer homepage failed...', e);
        }
      }
      return dispatch(setExplorerBrandHome({ brandId }));
    } return null;
  };
};

export const CREATE_EXPLORER_AUDIENCE = 'CREATE_EXPLORER_AUDIENCE';
export const createExplorerAudience = (createOpts) => {
  return async (dispatch, getState) => {
    const { brand: { id } } = getState().app;
    const URL = `/v2/brands/${id}/segments`;
    let response;
    try {
      response = await dispatch(postData(URL, createOpts));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('API call to create Explorer audience failed...', e);
      dispatch(
        showToast({
          state: 'ERROR',
          title: 'Error',
          message: 'Issue creating Explorer audience. Please try again later. If issue persists, please contact your Client Partner for support.',
          dismissible: true,
          dismissAfter: 10000,
        })
      );
      response = null;
    }
    return dispatch({
      type: CREATE_EXPLORER_AUDIENCE,
      payload: response,
    });
  };
};

export const PROCESS_EXPLORER_SEARCH = 'PROCESS_EXPLORER_SEARCH';
export const processSearchResults = (searchData) => {
  return async (dispatch) => {
    const searchFilters = parseFilters(searchData);
    const searchAudienceSize = parseAudienceSize(searchData);
    return dispatch({
      type: PROCESS_EXPLORER_SEARCH,
      payload: {
        searchData,
        searchFilters,
        searchAudienceSize,
      },
    });
  };
};

export const RESET_EXPLORER_SEARCH = 'RESET_EXPLORER_SEARCH';
export const resetSearchResults = () => {
  return async (dispatch) => {
    return dispatch({
      type: RESET_EXPLORER_SEARCH,
      payload: {
        searchData: null,
        searchFilters: [],
        searchAudienceSize: null,
      }
    });
  };
};

export default function reducer(state = defaultState, action = undefined) {
  switch (action.type) {
    case SET_EXPLORER_BRAND_HOME:
      return {
        ...state,
        brandHome: action?.payload,
        brandHomeLoading: false,
      };
    case SET_EXPLORER_BRAND_HOME_LOADING:
      return {
        ...state,
        brandHomeLoading: true,
      };
    case RESET_EXPLORER_BRAND_HOME:
      return {
        ...state,
        brandHome: defaultState.brandHome,
        brandHomeLoading: false,
      };
    case PROCESS_EXPLORER_SEARCH:
    case RESET_EXPLORER_SEARCH:
      return {
        ...state,
        searchData: action?.payload?.searchData,
        searchFilters: action?.payload?.searchFilters,
        searchAudienceSize: action?.payload?.searchAudienceSize,
      };
    case CREATE_EXPLORER_AUDIENCE:
      return {
        ...state,
        lastCreatedAudience: action?.payload,
      };
    default:
      return state;
  }
}
